import { useEffect, useState } from "react";
import "../../styles/Products.css";

const ProductGrid = () => {
  const [active, setActive] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const highlightGradient = "linear-gradient(135deg,#14b2ff,#586bff)";

  const products = [
    {
      id: 1,
      text: "Soochi – Lightweight ERP A simple ERP built for SMEs.Track invoices, payments, inventory, and daily operations without complexity or heavy setup.",
      logo: "/assets/products/soochilogo.png",
    },
    {
      id: 2,
      text: "ViCaaS – Community as a Service build and manage digital communities easily. Publish blogs, host events, handle registrations,and collect payments with built-in Razorpay integration ",
      logo: "/assets/products/vicaas.png",
    },
    {
      id: 3,
      text: "Happy Nenapu – Digital Flipbooks create brand flipbooks in minutes. Ready-made templates let you launch promotions fast with zero technical effort. ",
      logo: "/assets/products/happynenapulogo.png",
    },
    {
      id: 4,
      text: "Soochana – WhatsApp Business Logging Log sales and expenses directly from WhatsApp. No logins, no dashboards—just simple commands, with role-based access for control.",
      logo: "/assets/products/soochana.png",
    },
  ];

  useEffect(() => {
    if (isPaused) return;

    const timer = setInterval(
      () => setActive((prev) => (prev + 1) % products.length),
      2000
    );

    return () => clearInterval(timer);
  }, [isPaused]);

  return (
    <div className="product-section">
      <h1 className="product-title text-secondary">
        Our <span className="text-accent">Products</span> deliver excellence<br/>
        through future-ready solutions
      </h1>

      <div className="product-grid">
        {products.map((p, idx) => (
          <div
            key={p.id}
            className={`product-card text-secondary ${active === idx ? "active" : ""}`}
            style={{
              background: active === idx ? highlightGradient : "#161616",
            }}
            onMouseEnter={() => {
              setIsPaused(true);
              setActive(idx);
            }}
            onMouseLeave={() => setIsPaused(false)}
          >
            <p className="text-secondary">{p.text}</p>
          </div>
        ))}

        {/* center logo */}
        <div
          className="product-center-logo"
          style={{
            background: highlightGradient,
          }}
        >
          <img src={products[active].logo} alt="logo" />
        </div>
      </div>
    </div>
  );
};

export default ProductGrid;
